import cloneDeep from "lodash/cloneDeep";
import type { HistoryEntry } from "src/api/interfaces/history";
import type { RetrievalState } from "src/constants";
import type { ActionFunction, HistoryState } from "./types";

const setHistory: ActionFunction = (
  state: HistoryState,
  payload: {
    history: Array<HistoryEntry>;
    retrieveState: RetrievalState;
  }
) => {
  return {
    retrieveState: payload.retrieveState,
    history: cloneDeep(payload.history),
  };
};

export default setHistory;
